module.exports = __webpack_public_path__ + "media/images/pages/thermo-5a144ae0583bf9665b2ddefc0966a162.png";